import { Component } from '@angular/core';
import { AppNavigator, NavigatorTarget } from "../../services/app-navigator";
import { User } from "../../business/interfaces/User";
import { UserDatabase } from "../../business/database/user-database.service";
import { LoginAPI } from "../../business/apis/LoginAPI";
import { SidebarService } from "../../services/sidebar.service";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {

  currentUser: User | null = null

  constructor(private userDatabase: UserDatabase,
              private appNavigator: AppNavigator,
              private loginAPI : LoginAPI,
              private sidebarService: SidebarService) {

    console.log("HeaderComponent print")
  }

  ngOnInit(): void {
    this.currentUser = this.userDatabase.getCurrentUser();

    this.loginAPI.updateUserAuthentication()
  }

  logOut() {
    this.userDatabase.removeCurrentUser()
    this.appNavigator.navigateTo({target: NavigatorTarget.login});
  }

  editProfile() {
    this.appNavigator.navigateTo({target: NavigatorTarget.editProfile});
  }

  changePassword() {
    this.appNavigator.navigateTo({target: NavigatorTarget.changePassword});
  }

  toggleSidebar() {
    console.log("Toggling sidebar")
    this.sidebarService.toggleSidebar();
  }
}
